import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, Router } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '@env/environment';
import { classItInterceptor } from '@shared/interceptors/classit-api.interceptor';
import { NMFTAIconModule } from '@shared/components/atoms/icon/icon.module';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { SVG_ICONS } from '@shared/constants/icons';
import { provideGlobalErrorHandler } from '@core/error-handling/global-error-handler';
import { httpErrorInterceptor } from '@shared/interceptors/http-error.interceptor';
import { UserInactivityService } from '@shared/services/user-inactivity.service';

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './assets/i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([classItInterceptor, httpErrorInterceptor])),
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      NgxSkeletonLoaderModule.forRoot({
        animation: 'progress',
        theme: {
          extendsFromRoot: true,
          margin: 0,
          background: 'var(--Light-Grey-Grey-400, #e2e2e2)',
        },
      }),
      NMFTAIconModule.forRoot({
        icons: SVG_ICONS,
      }),
      OktaAuthModule.forRoot({
        oktaAuth: new OktaAuth({
          issuer: environment.oktaIssuer,
          clientId: environment.clientId,
          redirectUri: `${window.location.origin}/login/callback`,
          scopes: ['openid', 'profile', 'email', 'groups', 'groups_okta_users', 'org_info', 'offline_access'],
          responseType: 'code',
          pkce: true,
        }),
        onAuthRequired: (oktaAuth: OktaAuth, injector) => {
          const router = injector.get(Router);
          router.navigate(['/welcome']);
        },
      }),
    ]),
    provideEnvironmentNgxMask(),
    provideGlobalErrorHandler(),
  ],
};
